export const LOCALES = ["en-GB", "tr-TR"];
const en = {
    "chrome.poweredBy": "Powered by Wapadesk",
    "chrome.poweredByA11y": "Powered by Wapadesk, opens in a new tab",
    "chrome.continueOnWhatsApp": "Continue on WhatsApp",
    "chrome.chooseAgent": "Who would you like to message?",
    "chrome.continueStep": "Done, let's continue",
    "chrome.optional": "optional",
    "chrome.continueOnPhone": "Scan to continue on your phone",
    "chrome.phoneOffer": "On a computer? Continue on your phone",
    "chrome.phoneLoading": "Making your code…",
    "chrome.phoneHint": "Point your phone camera at the code. WhatsApp opens with your message. The code works for 15 minutes.",
    "chrome.phoneFailed": "The code could not be made. Please use the WhatsApp button.",
    "chrome.bookConsultation": "Book an appointment",
    "chrome.close": "Close",
    "chrome.subtitle": "A few quick questions",
    "chrome.send": "Next",
    "chrome.allHeadings": "Back to all services",
    "chrome.previewMessage": "Preview: this is the message the customer sends. Nothing was sent or saved.",
    "chrome.skipToWhatsApp": "Skip questions",
    "chrome.orBook": "or Book an appointment",
    "bp.closed": "Online booking is not open at the moment. Please contact us.",
    "bp.step.where": "Location",
    "bp.step.what": "Service",
    "bp.step.when": "Date and time",
    "bp.step.details": "Your details",
    "bp.step.pay": "Payment",
    "bp.step.done": "Confirmed",
    "bp.whereTitle": "Where would you like your appointment?",
    "bp.whatTitle": "What would you like to book?",
    "bp.whenTitle": "Choose a date and time",
    "bp.detailsTitle": "Your details",
    "bp.online": "Online video appointment",
    "bp.onlineSub": "From home, on your phone or computer",
    "bp.inClinic": "In person",
    "bp.treatment": "Service (optional)",
    "bp.treatmentHint": "Not sure yet? Leave this empty and tell us at the appointment.",
    "bp.firstName": "First name",
    "bp.lastName": "Last name",
    "bp.email": "Email",
    "bp.phone": "Mobile number",
    "bp.note": "Anything we should know? (optional)",
    "bp.consent": "I agree that {clinic} uses my details to arrange this appointment and to contact me about it.",
    "bp.privacy": "Privacy notice",
    "bp.marketing": "I would like to receive news and offers.",
    "bp.toPayment": "Continue to payment",
    "bp.phoneInvalid": "Please enter your mobile number with the country code, for example +44 7700 900123.",
    "bp.consentRequired": "Please tick the box to agree, so we can arrange your appointment.",
    "bp.checkDetails": "Please check your details.",
    "bp.emailed": "A confirmation is on its way to your email.",
    "bp.done": "Done",
    "pf.send": "Send",
    "pf.sentTitle": "Thank you, your message has been sent",
    "pf.sentBody": "Our team will be in touch with you shortly.",
    "pf.whatsAppHint": "Prefer WhatsApp? Continue there with everything you wrote.",
    "pf.challengeFailed": "We could not confirm this was sent by a person. Please try again, or message us on WhatsApp.",
    "bp.thanksTitle": "Booking complete",
    "bp.thanksBody": "Thank you{name}. Our team will be in touch with you shortly.",
    "bp.messageTeam": "Anything to add? Send your booking details to the team now.",
    "bp.sendByEmail": "Send by email",
    "bp.emailSent": "Sent. The team will reply by email.",
    "bp.handoffFailed": "That did not work. Please try again in a moment.",
    "booking.title": "Book an appointment",
    "booking.chooseProcedures": "What is it about? Pick one or more, or skip.",
    "booking.continue": "Continue",
    "booking.skipProcedures": "Skip this",
    "booking.chooseType": "Which appointment would you like?",
    "booking.chooseLocation": "Which location would you like to visit?",
    "booking.chooseDoctor": "Who would you like to see?",
    "booking.anyDoctor": "No preference",
    "booking.chooseTime": "Pick a day and time",
    "booking.free": "Free",
    "booking.paidSoon": "Online payment is coming soon; message us to book this one",
    "booking.min": "min",
    "booking.online": "Online",
    "booking.inPerson": "In person",
    "booking.noSlots": "No free times on this day",
    "booking.noSlotsWeek": "No free times this week",
    "booking.later": "Later",
    "booking.earlier": "Earlier",
    "booking.confirm": "Confirm booking",
    "booking.confirmed": "Your appointment is booked.",
    "booking.addGoogle": "Add to Google Calendar",
    "booking.addIcs": "Download for Apple or Outlook",
    "booking.timesIn": "Times are shown in your time zone",
    "booking.back": "Back",
    "booking.notNow": "Not now",
    "booking.taken": "That time has just been taken. Please pick another.",
    "booking.contactFirst": "Please answer the contact questions first so we can confirm your booking.",
    "booking.unavailable": "Online booking is not available right now. You can continue on WhatsApp.",
    "booking.with": "with",
    "pay.title": "Your deposit",
    "pay.intro": "{clinic} asks for a deposit of {amount}.",
    "pay.forAppointment": "Appointment",
    "pay.continue": "Continue to payment",
    "pay.payTitle": "Pay your deposit",
    "pay.payNote": "Card payment, straight to our own account. Your card details never reach Wapadesk.",
    "pay.paid": "Thank you{name}. Your deposit is paid and the team has been told.",
    "pay.closed": "This payment request is no longer open. Please contact us.",
    "pay.refunded": "This deposit has been refunded.",
    "pay.unavailable": "Card payment is not available right now. Please contact us.",
    "pay.notFound": "This payment link is not valid. Please ask us for a new one.",
    "booking.payTitle": "Pay to confirm your appointment",
    "booking.payNote": "Your time is held for 15 minutes while you pay. The payment goes to the business directly.",
    "booking.payButton": "Pay",
    "booking.paying": "Confirming your payment…",
    "booking.payFailed": "The payment did not go through. You can try another card.",
    "booking.payExpired": "The hold expired before the payment completed. Please pick a time again.",
    "booking.paid": "Payment received.",
    "chrome.skip": "Skip",
    "chrome.accept": "Agree and continue",
    "chrome.decline": "No thanks",
    "chrome.privacyPolicy": "Privacy policy",
    "chrome.help": "More information",
    "chrome.edit": "Edit answer",
    "chrome.other": "Other",
    "chrome.otherPlaceholder": "Please specify",
    "chrome.addFiles": "Add photos or files",
    "chrome.takePhoto": "Take a photo",
    "chrome.done": "Done",
    "chrome.uploading": "Uploading…",
    "chrome.uploadFailed": "Upload failed, please try again",
    "chrome.saving": "Saving…",
    "chrome.saved": "Saved",
    "chrome.completed": "Thank you, that is everything. I am connecting you to our team on WhatsApp now.",
    "chrome.openWhatsApp": "Take me to WhatsApp",
    "chrome.sendByEmail": "Send by email instead",
    "chrome.sendingEmail": "Sending…",
    "chrome.emailSent": "Sent. The team will reply by email, usually within one working day.",
    "chrome.emailFailed": "That did not send. Please use WhatsApp, or try again in a moment.",
    "chrome.whatsappHint": "WhatsApp will open with your answers filled in. Press send to start the conversation.",
    "chrome.fallbackTitle": "Message us on WhatsApp",
    "chrome.fallbackBody": "Tap below to start a WhatsApp conversation with us.",
    "chrome.errorTitle": "Something went wrong",
    "chrome.errorBody": "Your answers are safe. You can continue on WhatsApp.",
    "chrome.notOnThisSite": "This form is not available on this website.",
    "chrome.sessionExpired": "This conversation has expired. Please start again.",
    "chrome.yourAnswer": "Your answer",
    "chrome.selectCountry": "Country code",
    "validation.required": "This answer is required.",
    "validation.too_long": "That is a little too long.",
    "validation.invalid_email": "Please enter a valid email address.",
    "validation.invalid_phone": "Please enter a valid phone number with country code.",
    "validation.not_a_number": "Please enter a number.",
    "validation.out_of_range": "That value is outside the allowed range.",
    "validation.invalid_date": "Please enter a valid date.",
    "validation.invalid_option": "Please choose one of the options.",
    "validation.too_many": "Too many selected.",
    "validation.consent_required": "Please agree to continue.",
    "validation.network": "Could not connect. Please try again.",
};
const tr = {
    "chrome.poweredBy": "Wapadesk altyapısıyla",
    "chrome.poweredByA11y": "Wapadesk altyapısıyla, yeni sekmede açılır",
    "chrome.continueOnWhatsApp": "WhatsApp'ta devam et",
    "chrome.chooseAgent": "Kiminle yazışmak istersiniz?",
    "chrome.continueStep": "Tamam, devam edelim",
    "chrome.optional": "isteğe bağlı",
    "chrome.continueOnPhone": "Telefonunuzda devam etmek için okutun",
    "chrome.phoneOffer": "Bilgisayarda mısınız? Telefonunuzda devam edin",
    "chrome.phoneLoading": "Kodunuz hazırlanıyor…",
    "chrome.phoneHint": "Telefonunuzun kamerasını koda tutun. WhatsApp mesajınızla açılır. Kod 15 dakika geçerlidir.",
    "chrome.phoneFailed": "Kod oluşturulamadı. Lütfen WhatsApp butonunu kullanın.",
    "chrome.bookConsultation": "Randevu al",
    "chrome.close": "Kapat",
    "chrome.subtitle": "Birkaç kısa soru",
    "chrome.send": "İleri",
    "chrome.allHeadings": "Tüm hizmetlere dön",
    "chrome.previewMessage": "Önizleme: müşterinin göndereceği mesaj budur. Hiçbir şey gönderilmedi ya da kaydedilmedi.",
    "chrome.skipToWhatsApp": "Soruları atla",
    "chrome.orBook": "ya da Randevu al",
    "bp.closed": "Online randevu şu anda açık değil. Lütfen bizimle iletişime geçin.",
    "bp.step.where": "Lokasyon",
    "bp.step.what": "Hizmet",
    "bp.step.when": "Tarih ve saat",
    "bp.step.details": "Bilgileriniz",
    "bp.step.pay": "Ödeme",
    "bp.step.done": "Onaylandı",
    "bp.whereTitle": "Randevunuz nerede olsun?",
    "bp.whatTitle": "Ne için randevu almak istersiniz?",
    "bp.whenTitle": "Tarih ve saat seçin",
    "bp.detailsTitle": "Bilgileriniz",
    "bp.online": "Online görüntülü görüşme",
    "bp.onlineSub": "Evden, telefon veya bilgisayarınızla",
    "bp.inClinic": "Yüz yüze",
    "bp.treatment": "Hizmet (isteğe bağlı)",
    "bp.treatmentHint": "Emin değil misiniz? Boş bırakın, randevuda konuşalım.",
    "bp.firstName": "Ad",
    "bp.lastName": "Soyad",
    "bp.email": "E-posta",
    "bp.phone": "Cep telefonu",
    "bp.note": "Bilmemiz gereken bir şey var mı? (isteğe bağlı)",
    "bp.consent": "{clinic} bilgilerimi bu randevuyu ayarlamak ve benimle bu konuda iletişim kurmak için kullanabilir.",
    "bp.privacy": "Gizlilik bildirimi",
    "bp.marketing": "Haber ve kampanyaları almak istiyorum.",
    "bp.toPayment": "Ödemeye geç",
    "bp.phoneInvalid": "Lütfen cep telefonunuzu ülke koduyla girin, örneğin +90 532 000 0000.",
    "bp.consentRequired": "Randevunuzu ayarlayabilmemiz için lütfen onay kutusunu işaretleyin.",
    "bp.checkDetails": "Lütfen bilgilerinizi kontrol edin.",
    "bp.emailed": "Onay e-postanıza gönderiliyor.",
    "bp.done": "Tamam",
    "pf.send": "Gönder",
    "pf.sentTitle": "Teşekkürler, mesajınız gönderildi",
    "pf.sentBody": "Ekibimiz en kısa sürede sizinle iletişime geçecek.",
    "pf.whatsAppHint": "WhatsApp'ı mı tercih edersiniz? Yazdıklarınızla birlikte orada devam edin.",
    "pf.challengeFailed": "Bu gönderimin bir kişiden geldiğini doğrulayamadık. Lütfen tekrar deneyin ya da bize WhatsApp'tan yazın.",
    "bp.thanksTitle": "Randevunuz tamamlandı",
    "bp.thanksBody": "Teşekkürler{name}. Ekibimiz en kısa sürede sizinle iletişime geçecek.",
    "bp.messageTeam": "Eklemek istediğiniz bir şey var mı? Randevu bilgilerinizi ekibe şimdi gönderin.",
    "bp.sendByEmail": "E-postayla gönder",
    "bp.emailSent": "Gönderildi. Ekip e-postayla yanıt verecek.",
    "bp.handoffFailed": "Bu işlem olmadı. Lütfen biraz sonra tekrar deneyin.",
    "booking.title": "Randevu al",
    "booking.chooseProcedures": "Konu nedir? Bir veya birkaçını seçin ya da atlayın.",
    "booking.continue": "Devam",
    "booking.skipProcedures": "Atla",
    "booking.chooseType": "Hangi randevu türünü istersiniz?",
    "booking.chooseLocation": "Hangi lokasyona gelmek istersiniz?",
    "booking.chooseDoctor": "Kimi görmek istersiniz?",
    "booking.anyDoctor": "Fark etmez",
    "booking.chooseTime": "Gün ve saat seçin",
    "booking.free": "Ücretsiz",
    "booking.paidSoon": "Online ödeme yakında; bunun için bize yazın",
    "booking.min": "dk",
    "booking.online": "Online",
    "booking.inPerson": "Yüz yüze",
    "booking.noSlots": "Bu gün boş saat yok",
    "booking.noSlotsWeek": "Bu hafta boş saat yok",
    "booking.later": "Sonrası",
    "booking.earlier": "Öncesi",
    "booking.confirm": "Randevuyu onayla",
    "booking.confirmed": "Randevunuz alındı.",
    "booking.addGoogle": "Google Takvim'e ekle",
    "booking.addIcs": "Apple veya Outlook için indir",
    "booking.timesIn": "Saatler sizin saat diliminizde gösteriliyor",
    "booking.back": "Geri",
    "booking.notNow": "Şimdi değil",
    "booking.taken": "Bu saat az önce alındı. Lütfen başka bir saat seçin.",
    "booking.contactFirst": "Randevuyu onaylayabilmemiz için önce iletişim sorularını cevaplayın.",
    "booking.unavailable": "Online randevu şu anda kullanılamıyor. WhatsApp'tan devam edebilirsiniz.",
    "booking.with": "ile",
    "pay.title": "Depozitonuz",
    "pay.intro": "{clinic} {amount} depozito talep ediyor.",
    "pay.forAppointment": "Randevu",
    "pay.continue": "Ödemeye geç",
    "pay.payTitle": "Depozitonuzu ödeyin",
    "pay.payNote": "Kartla ödeme, doğrudan kendi hesabımıza. Kart bilgileriniz Wapadesk'e ulaşmaz.",
    "pay.paid": "Teşekkürler{name}. Depozitonuz ödendi ve ekip bilgilendirildi.",
    "pay.closed": "Bu ödeme talebi artık açık değil. Lütfen bizimle iletişime geçin.",
    "pay.refunded": "Bu depozito iade edildi.",
    "pay.unavailable": "Kartla ödeme şu anda kullanılamıyor. Lütfen bizimle iletişime geçin.",
    "pay.notFound": "Bu ödeme bağlantısı geçerli değil. Lütfen bizden yeni bir bağlantı isteyin.",
    "booking.payTitle": "Randevuyu onaylamak için ödeme yapın",
    "booking.payNote": "Ödeme sırasında saatiniz 15 dakika tutulur. Ödeme doğrudan işletmeye gider.",
    "booking.payButton": "Öde",
    "booking.paying": "Ödemeniz doğrulanıyor…",
    "booking.payFailed": "Ödeme gerçekleşmedi. Başka bir kartla deneyebilirsiniz.",
    "booking.payExpired": "Ödeme tamamlanmadan süre doldu. Lütfen tekrar bir saat seçin.",
    "booking.paid": "Ödeme alındı.",
    "chrome.skip": "Atla",
    "chrome.accept": "Kabul et ve devam et",
    "chrome.decline": "Hayır, teşekkürler",
    "chrome.privacyPolicy": "Gizlilik politikası",
    "chrome.help": "Daha fazla bilgi",
    "chrome.edit": "Cevabı düzenle",
    "chrome.other": "Diğer",
    "chrome.otherPlaceholder": "Lütfen belirtin",
    "chrome.addFiles": "Fotoğraf veya dosya ekle",
    "chrome.takePhoto": "Fotoğraf çek",
    "chrome.done": "Tamam",
    "chrome.uploading": "Yükleniyor…",
    "chrome.uploadFailed": "Yükleme başarısız, lütfen tekrar deneyin",
    "chrome.saving": "Kaydediliyor…",
    "chrome.saved": "Kaydedildi",
    "chrome.completed": "Teşekkürler, hepsi bu kadar. Sizi WhatsApp üzerinden ekibimize aktarıyorum.",
    "chrome.openWhatsApp": "WhatsApp'a aktar",
    "chrome.sendByEmail": "Bunun yerine e-posta gönder",
    "chrome.sendingEmail": "Gönderiliyor…",
    "chrome.emailSent": "Gönderildi. Ekip genellikle bir iş günü içinde e-postayla yanıt verir.",
    "chrome.emailFailed": "Gönderilemedi. Lütfen WhatsApp kullanın ya da biraz sonra tekrar deneyin.",
    "chrome.whatsappHint": "WhatsApp cevaplarınız doldurulmuş olarak açılacak. Konuşmayı başlatmak için gönder'e basın.",
    "chrome.fallbackTitle": "Bize WhatsApp'tan yazın",
    "chrome.fallbackBody": "Bizimle WhatsApp üzerinden konuşmaya başlamak için aşağıya dokunun.",
    "chrome.errorTitle": "Bir sorun oluştu",
    "chrome.errorBody": "Cevaplarınız güvende. WhatsApp'ta devam edebilirsiniz.",
    "chrome.notOnThisSite": "Bu form bu web sitesinde kullanılamıyor.",
    "chrome.sessionExpired": "Bu konuşmanın süresi doldu. Lütfen yeniden başlayın.",
    "chrome.yourAnswer": "Cevabınız",
    "chrome.selectCountry": "Ülke kodu",
    "validation.required": "Bu cevap zorunludur.",
    "validation.too_long": "Biraz fazla uzun oldu.",
    "validation.invalid_email": "Lütfen geçerli bir e-posta adresi girin.",
    "validation.invalid_phone": "Lütfen ülke koduyla geçerli bir telefon numarası girin.",
    "validation.not_a_number": "Lütfen bir sayı girin.",
    "validation.out_of_range": "Bu değer izin verilen aralığın dışında.",
    "validation.invalid_date": "Lütfen geçerli bir tarih girin.",
    "validation.invalid_option": "Lütfen seçeneklerden birini seçin.",
    "validation.too_many": "Çok fazla seçim yapıldı.",
    "validation.consent_required": "Devam etmek için lütfen onaylayın.",
    "validation.network": "Bağlantı kurulamadı. Lütfen tekrar deneyin.",
};
const catalogues = { "en-GB": en, "tr-TR": tr };
/** Returns the translation, falling back to en-GB. The brand name is never translated. */
export function t(locale, key) {
    const l = LOCALES.includes(locale) ? locale : "en-GB";
    return catalogues[l][key] ?? en[key];
}
export function resolveLocale(candidate) {
    if (!candidate)
        return "en-GB";
    const lower = candidate.toLowerCase();
    if (lower.startsWith("tr"))
        return "tr-TR";
    return "en-GB";
}
//# sourceMappingURL=index.js.map